import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-matriz-ssoma',
  templateUrl: './matriz-ssoma.component.html',
  styleUrls: ['./matriz-ssoma.component.css']
})
export class MatrizSsomaComponent {

  constructor(private sanitizer: DomSanitizer) { }
  pdfSrc: SafeResourceUrl | undefined;

  loadPdf(pdfName: string) {
    this.pdfSrc = undefined
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl( `assets/pdfs/matriz-ssoma/${pdfName}`);
  }

}
